/* LUCCINI – כניסת לקוחות סיטונאים (29.09.2026)
   שם משתמש = מפתח החשבון (290...), סיסמה אישית.
   המחירון הסיטונאי (לפני מע"מ, שקלים שלמים) שמור מוצפן בקובץ assets/lx-ws-data.json.
   רק סיסמה נכונה פותחת את מפתח ההצפנה (PBKDF2-SHA256 + AES-GCM), כך שבלי סיסמה אין דרך לקרוא מחירים.
   לקוח מחובר: רואה בכל האתר את המחיר הסיטונאי, "הוספה לסל" מוסיפה לסל סיטונאי נפרד,
   וההזמנה נשלחת לבעל החנות בטופס יצירת הקשר של Shopify (או בוואטסאפ) – בלי קופה ובלי סליקה.
   סוכן (מ-29.09.2026): נכנס עם שם משתמש וסיסמה של סוכן, בוחר חנות מרשימה (הקלדת אותיות מהשם או ספרות ממספר הלקוח)
   ומזמין עבורה. רשימת החנויות מוצפנת בנפרד ונפתחת רק בסיסמת סוכן. במייל מצוין שההזמנה בוצעה ע״י הסוכן.
   30.09.2026: שליחת ההזמנה בטופס #lx-ws-order שנמצא בדף מההתחלה (snippets/luccini-wholesale-form.liquid)
   ובשליחה רגילה (requestSubmit), כדי שבדיקת "אני לא רובוט" של Shopify תוסיף את האסימון שלה.
   תמונה בסל: נשמרת אוטומטית ברגע ההוספה מהדף עצמו (כרטיס מוצר / דף מוצר) – בלי קובץ שצריך לתחזק.
   01.10.2026: שליחה מטופס מוסתר אושרה ע"י Shopify אבל לא הגיעה למייל (סומנה כחשודה). לכן "שליחת ההזמנה" מעבירה
   לדף "צור קשר" (/pages/contact?ws=send), שם הטופס הרגיל של Shopify ממולא מראש והמשתמש לוחץ "שליחה" בעצמו –
   אותו מסלול שנבדק והגיע.
   01.10.2026 (ערב): הכול עובד כמו אצל לקוח פרטי – בלי פס תחתון. הסל הוא עמוד הסל הרגיל (/cart) ומציג את הסל הסיטונאי;
   המספר על אייקון הסל תמיד מוצג (גם 0); כפתור החשבון בראש האתר מציג את שם החנות (וחנות לסוכן) ופותח תפריט קטן:
   סוכן – "החלפת חנות" ו"התנתקות"; חנות – "התנתקות". בלי חלונות הדרכה.
   01.10.2026 (לילה): "שליחת ההזמנה" שולחת ישירות מהסל דרך EmailJS (חשבון infoluccini@gmail.com, שירות Gmail),
   במייל מעוצב: ימין-לשמאל, רשימת פריטים (כל פריט בשתי שורות – 03.10.2026), סיכום בצד שמאל, הערות מודגשות. אם השליחה נכשלת – מעבר מיידי לדף
   "צור קשר" עם הטופס ממולא (‎?ws=send&fb=1), לחיצה אחת על "שלח" ושולחים דרך Shopify. */
(function () {
  'use strict';
  if (window.__lxWs) return;
  window.__lxWs = true;

  var CFG = window.LXWS_CFG || {};
  var KEY = 'lxws', BASKET = 'lxws-basket', PENDING = 'lxws-pending', STORE = 'lxws-store', SEND = 'lxws-send', NOTE = 'lxws-note';
  var ON_HOME = location.pathname === '/' || location.pathname === '';
  var ON_CART = /^\/cart\/?$/.test(location.pathname);
  var VAT = 0.18;
  var subtle = window.crypto && window.crypto.subtle;
  var html = document.documentElement;
  var session = null, PRICES = null, VMAP = {}, dataPromise = null, STORES = null;

  /* ---------- כלים ---------- */
  function b64d(s) { var b = atob(s), u = new Uint8Array(b.length); for (var i = 0; i < b.length; i++) u[i] = b.charCodeAt(i); return u; }
  function b64e(u) { var s = ''; for (var i = 0; i < u.length; i++) s += String.fromCharCode(u[i]); return btoa(s); }
  function enc(s) { return new TextEncoder().encode(s); }
  function dec(b) { return new TextDecoder().decode(b); }
  function cat(a, b) { var u = new Uint8Array(a.length + b.length); u.set(a, 0); u.set(b, a.length); return u; }
  function n2(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function money2(n) { var f = (Math.round(n * 100) / 100).toFixed(2).split('.'); return f[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + f[1]; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readStore(k) { try { return JSON.parse(localStorage.getItem(k) || sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function el(tag, attrs, htmlText) { var e = document.createElement(tag); if (attrs) for (var a in attrs) e.setAttribute(a, attrs[a]); if (htmlText != null) e.innerHTML = htmlText; return e; }

  function getData() {
    if (!dataPromise) {
      dataPromise = fetch(CFG.data, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('data'); return r.json();
      });
      dataPromise.catch(function () { dataPromise = null; });
    }
    return dataPromise;
  }

  function login(code, pw) {
    code = String(code || '').replace(/\s+/g, '');
    return getData().then(function (data) {
      var u = data.u[code];
      if (!u || !pw) throw new Error('bad');
      return subtle.importKey('raw', enc(pw), 'PBKDF2', false, ['deriveKey']).then(function (base) {
        return subtle.deriveKey({ name: 'PBKDF2', salt: cat(b64d(u.s), enc(code)), iterations: data.it, hash: 'SHA-256' },
          base, { name: 'AES-GCM', length: 256 }, false, ['decrypt']);
      }).then(function (k) {
        return subtle.decrypt({ name: 'AES-GCM', iv: b64d(u.i), additionalData: enc(code) }, k, b64d(u.w));
      }).then(function (plain) {
        var o = JSON.parse(dec(plain));
        var s = { c: o.c, n: o.n, k: o.k };
        if (o.r === 'a' && o.ak) { s.r = 'a'; s.ak = o.ak; }
        return s;
      }, function () { throw new Error('bad'); });
    });
  }

  function loadPrices(sess) {
    return getData().then(function (data) {
      return subtle.importKey('raw', b64d(sess.k), 'AES-GCM', false, ['decrypt']).then(function (k) {
        return subtle.decrypt({ name: 'AES-GCM', iv: b64d(data.d.i), additionalData: enc('lx-data') }, k, b64d(data.d.c));
      }).then(function (plain) { return JSON.parse(dec(plain)); });
    });
  }

  function loadVmap() {
    if (!CFG.vmap) return Promise.resolve({});
    return fetch(CFG.vmap, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; });
  }

  function loadStores(sess) {
    return getData().then(function (data) {
      if (!data.a) throw new Error('no-agent-data');
      return subtle.importKey('raw', b64d(sess.ak), 'AES-GCM', false, ['decrypt']).then(function (k) {
        return subtle.decrypt({ name: 'AES-GCM', iv: b64d(data.a.i), additionalData: enc('lx-agent') }, k, b64d(data.a.c));
      }).then(function (plain) { return JSON.parse(dec(plain)).s; });
    });
  }
  function isAgent() { return !!(session && session.r === 'a'); }
  function curStore() { try { return JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) { return null; } }
  function setStore(st) { try { if (st) sessionStorage.setItem(STORE, JSON.stringify(st)); else sessionStorage.removeItem(STORE); } catch (e) {} refresh(); }

  /* ---------- סל סיטונאי ---------- */
  function basket() { try { return JSON.parse(localStorage.getItem(BASKET) || '[]'); } catch (e) { return []; } }
  function saveBasket(b) { try { localStorage.setItem(BASKET, JSON.stringify(b)); } catch (e) {} refresh(); }
  function priceOf(sku) { return PRICES && Object.prototype.hasOwnProperty.call(PRICES, sku) ? PRICES[sku] : null; }
  function totals(b) {
    var sub = 0, missing = 0, qty = 0;
    b.forEach(function (l) { var p = priceOf(l.sku); qty += l.q; if (p == null) missing++; else sub += p * l.q; });
    var vat = Math.round(sub * VAT * 100) / 100;
    /* כמו בחשבונית: לפני מע"מ ומע"מ באגורות; השורה האחרונה (כולל מע"מ) מעוגלת לשקלים שלמים */
    return { sub: sub, vat: vat, total: Math.round(sub + vat), missing: missing, qty: qty };
  }

  /* ---------- הצגת מחירים ---------- */
  var applying = false;
  function priceHtml(sku) {
    var p = priceOf(sku);
    if (p == null) return '<span class="lx-ws-ask">מחיר לפי בקשה</span>';
    return '₪' + n2(p) + ' <span class="lx-ws-vat">+ מע״מ</span>';
  }
  function setHtml(node, h) { if (node.innerHTML !== h) node.innerHTML = h; node.classList.add('lx-ws-ok'); }

  function currentProductSku() {
    var s = document.querySelector('main .lx-pv__sku');
    return s ? s.textContent.trim() : '';
  }

  function applyPrices() {
    if (!PRICES || applying) return;
    applying = true;
    try {
      document.querySelectorAll('[data-lx-card]').forEach(function (c) {
        var s = c.querySelector('[data-lx-sku]'), p = c.querySelector('[data-lx-price]');
        if (s && p) setHtml(p, priceHtml(s.textContent.trim()));
      });
      document.querySelectorAll('.lx-pr__p').forEach(function (p) {
        var box = p.parentElement, inp = box && box.querySelector('input[name="id"]');
        var vs = inp && VMAP[inp.value];
        if (vs) setHtml(p, priceHtml(vs));
      });
      var sku = currentProductSku();
      if (sku) {
        document.querySelectorAll('main product-price, sticky-add-to-cart product-price').forEach(function (pp) {
          var bdi = pp.querySelector('.price bdi') || pp.querySelector('.price');
          if (bdi) { var h = priceHtml(sku); if (bdi.innerHTML !== h) bdi.innerHTML = h; }
          var cmp = pp.querySelector('.compare-at-price'); if (cmp) cmp.style.display = 'none';
          pp.classList.add('lx-ws-ok');
        });
      }
    } finally { applying = false; }
  }

  var queued = false;
  function queueApply() { if (queued) return; queued = true; Promise.resolve().then(function () { queued = false; applyPrices(); }); }

  /* ---------- מצב מחובר / מנותק ---------- */
  function startSession(sess, silent) {
    return Promise.all([loadPrices(sess), loadVmap()]).then(function (r) {
      var p = r[0]; if (!p.v) p.v = r[1];
      if (sess.r !== 'a') return p;
      return loadStores(sess).then(function (st) { STORES = st; return p; });
    }).then(function (p) {
      PRICES = p.p; VMAP = p.v || {}; session = sess;
      html.classList.add('lx-ws');
      applyPrices();
      new MutationObserver(function () { if (!applying) queueApply(); })
        .observe(document.body, { childList: true, subtree: true, characterData: true });
      refresh();
      if (waitAdd) { var w = waitAdd; waitAdd = null; addFromForm(w.f, w.b); }
      checkPosted();
      prepareSend();

    });
  }

  function logout() {
    try { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); localStorage.removeItem(BASKET); sessionStorage.removeItem(STORE); sessionStorage.removeItem(SEND); sessionStorage.removeItem(NOTE); } catch (e) {}
    location.href = '/';
  }

  /* ---------- הוספה לסל ---------- */
  function variantsJson() {
    var e = document.querySelector('[data-lx-variants]');
    if (!e) return [];
    try { return JSON.parse(e.textContent); } catch (x) { return []; }
  }

  function addFromForm(form, btn) {
    var idInput = form && form.querySelector('[name="id"]');
    var vid = idInput ? +idInput.value : 0;
    var qInput = (form && form.querySelector('[name="quantity"]')) || (form && form.closest('main') && document.querySelector('main input[name="quantity"]'));
    var q = Math.max(1, parseInt(qInput && qInput.value, 10) || 1);
    var sku = VMAP[vid] || '', name = '';
    variantsJson().forEach(function (v) { if (v.id === vid) { sku = sku || v.sku; name = v.name; } });
    if (!name) {
      var box = form.closest('.lx-pr') ? form.parentElement : null, tt = box && box.querySelector('.lx-pr__t');
      if (tt) name = tt.textContent.trim();
    }
    var card = cardOf(form);
    if (card) {
      var cs = card.querySelector('[data-lx-sku]'), cn = card.querySelector('[data-lx-name]');
      if (!sku && cs) sku = cs.textContent.trim();
      if (!name && cn) name = cn.textContent.trim();
    }
    if ((!sku || !name) && currentProductSku() && form.closest('main')) {
      sku = sku || currentProductSku();
      var t = document.querySelector('main .lx-title') || document.querySelector('main h1');
      name = name || (t ? t.textContent.trim() : '');
    }
    if (!sku) { toast('לא ניתן להוסיף את המוצר הזה לסל. נא לפתוח את דף המוצר ולהוסיף משם.'); return; }
    var img = imgFor(form, card);
    var b = basket(), found = false;
    b.forEach(function (l) { if (l.sku === sku) { l.q += q; found = true; if (!l.img && img) l.img = img; } });
    if (!found) b.push({ sku: sku, n: name, id: vid, q: q, img: img });
    saveBasket(b);
    /* כמו אצל לקוח פרטי: הכפתור ירוק עם ✓ לשתי שניות, ואייקון הסל "קופץ" עם המספר החדש */
    if (btn && !btn.classList.contains('lx-ws-added')) {
      var old = btn.innerHTML;
      btn.classList.add('lx-ws-added', 'lx-added'); btn.innerHTML = '✓ נוסף לסל';
      setTimeout(function () { btn.classList.remove('lx-ws-added', 'lx-added'); btn.innerHTML = old; }, 2000);
    }
    document.querySelectorAll('.lx-hd__cart').forEach(function (c) { c.classList.remove('lx-bump'); void c.offsetWidth; c.classList.add('lx-bump'); });
  }

  /* הכרטיס שבו נמצא טופס ההוספה (דף הבית / קטלוג), אם יש */
  function cardOf(form) {
    var box = form && (form.closest('[data-lx-card]') || (form.parentElement && form.parentElement.querySelector('[data-lx-card]')));
    return box || null;
  }
  /* תמונה קטנה לסל: מהכרטיס; בדף מוצר – התמונה הראשית; ואם אין – תמונת השיתוף של הדף */
  function smallImg(u) {
    if (!u) return '';
    u = String(u).trim();
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (!/^https?:\/\//.test(u)) return '';
    u = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }
  function imgFor(form, card) {
    try {
      var i = card && (card.querySelector('[data-lx-img]') || card.querySelector('img'));
      if (i) return smallImg(i.currentSrc || i.src);
      if (form && form.closest('main')) {
        var g = document.querySelector('main media-gallery img');
        if (g && (g.currentSrc || g.src)) return smallImg(g.currentSrc || g.src);
        var og = document.querySelector('meta[property="og:image:secure_url"]') || document.querySelector('meta[property="og:image"]');
        if (og) return smallImg(og.getAttribute('content'));
      }
    } catch (e) {}
    return '';
  }

  function interceptForm(target) {
    var form = target.closest && (target.closest('form[action*="/cart/add"]') ||
      (target.form && /\/cart\/add/.test(target.form.getAttribute('action') || '') ? target.form : null));
    if (!form) {
      var comp = target.closest && target.closest('product-form-component');
      if (comp) form = comp.querySelector('form[action*="/cart/add"]');
    }
    return form;
  }

  /* סיטונאי מחובר שלוחץ "הוספה לסל" לפני שסיום הטעינה: הלחיצה נשמרת ומתבצעת מיד בסיום, ולא נכנסת לסל הרגיל */
  var waitAdd = null;
  function wsPending() { return !session && html.classList.contains('lx-ws'); }
  function doAdd(form, btn) { if (session) addFromForm(form, btn); else waitAdd = { f: form, b: btn }; }

  window.addEventListener('submit', function (e) {
    if (!session && !wsPending()) return;
    var f = e.target;
    if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) { e.preventDefault(); e.stopImmediatePropagation(); doAdd(f, e.submitter || f.querySelector('button[type="submit"]')); }
  }, true);

  window.addEventListener('click', function (e) {
    if (!session && !wsPending()) return;
    var btn = e.target.closest && e.target.closest('button[name="add"], .add-to-cart-button, button[type="submit"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var form = interceptForm(btn);
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    doAdd(form, btn);
  }, true);

  /* ---------- ממשק (כמו אצל לקוח פרטי) ---------- */
  var dlgLogin, dlgStore, toastEl, menuEl, cartBox, menuAnchor = null, menuAnchorTop = 0;

  function toast(msg) {
    if (!toastEl) { toastEl = el('div', { class: 'lx-ws-toast', role: 'status', 'aria-live': 'polite' }); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toast.t); toast.t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 5000);
  }

  /* אחרי כניסה / בחירת חנות: בדף הבית – גלילה לעיגולי הקטגוריות ("קנייה לפי קטגוריה"); מכל דף אחר נשארים בו */
  function goShop() {
    if (!ON_HOME) return;
    var c = document.querySelector('.lx-cats');
    if (c) c.scrollIntoView({ block: 'start' }); else location.href = '/collections/all';
  }

  /* רענון כל מה שמוצג: המספר על אייקון הסל, כפתור החשבון, ועמוד הסל */
  function refresh() { renderHeader(); renderCart(); }

  /* "כניסת סיטונאים" בראש האתר ובתפריט הנייד (02.10.2026): לחיצה פותחת את חלון הכניסה במקום מעבר לדף.
     בלי JavaScript הקישור עצמו (‎/?ws=login) פותח את אותו חלון בדף הבית.
     02.10.2026 (סשן 13): גם בפס העליון בטלפון (a.lx-top__ws), כדי שיראו את הכניסה מיד בלי לפתוח את ☰.
     בתפריט ☰ אין יותר כניסה (הוסרה מ-sections/header-group.json); הבורר a.lx-hd__mlogin נשאר רק ליתר ביטחון. */
  function buildEntry() {
    document.querySelectorAll('a.lx-hd__login, a.lx-hd__mlogin, a.lx-top__ws').forEach(function (a) {
      if (a.dataset.lxe) return;
      a.dataset.lxe = '1';
      a.addEventListener('click', function (e) {
        if (session) return;
        e.preventDefault();
        var mm = a.closest('details'); if (mm) mm.removeAttribute('open');
        openLogin();
      });
    });
  }

  function buildLogin() {
    if (dlgLogin) return;
    dlgLogin = el('dialog', { class: 'lx-ws-dlg', 'aria-labelledby': 'lx-ws-lt' },
      '<form class="lx-ws-form" method="post" action="#" autocomplete="on">' +
      '<button type="button" class="lx-ws-x" aria-label="סגירה">×</button>' +
      '<button type="button" class="lx-ws-pv" data-x="close"><span class="lx-ws-pv__a">לקוח פרטי? אין צורך בכניסה</span><span class="lx-ws-pv__b">להמשך קנייה באתר</span></button>' +
      '<p class="lx-ws-alt lx-ws-alt--sub">רוצים לפתוח חשבון סיטונאי? <a class="lx-ws-link" href="/pages/contact">צרו קשר</a></p>' +
      '<h2 id="lx-ws-lt">כניסת לקוחות סיטונאים</h2>' +
      '<p class="lx-ws-sub">לחנויות, לסיטונאים ולסוכנים עם חשבון ב-LUCCINI</p>' +
      '<label for="lx-ws-u">שם משתמש (מספר לקוח או שם סוכן)</label>' +
      '<input id="lx-ws-u" name="username" autocomplete="username" dir="auto" autocapitalize="off" spellcheck="false" required>' +
      '<label for="lx-ws-p">סיסמה</label>' +
      '<input id="lx-ws-p" name="password" type="password" autocomplete="current-password" dir="ltr" required>' +
      '<label class="lx-ws-rem"><input type="checkbox" name="remember" checked> זכור אותי במכשיר הזה</label>' +
      '<p class="lx-ws-err" role="alert" hidden></p>' +
      '<button type="submit" class="lx-ws-btn">כניסה</button>' +
      '</form>');
    document.body.appendChild(dlgLogin);
    var form = dlgLogin.querySelector('form');
    dlgLogin.querySelector('.lx-ws-x').addEventListener('click', function () { dlgLogin.close(); });
    /* לקוח פרטי שפתח את החלון בטעות: כל התיבה הזהב "לקוח פרטי? ... להמשך קנייה באתר" לחיצה וסוגרת את החלון (02.10.2026) */
    dlgLogin.querySelector('[data-x="close"]').addEventListener('click', function () { dlgLogin.close(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = form.querySelector('.lx-ws-err'), btn = form.querySelector('.lx-ws-btn');
      err.hidden = true; btn.disabled = true; btn.textContent = 'בודק...';
      if (!subtle) { err.textContent = 'הדפדפן אינו תומך בכניסה מאובטחת. נא לעדכן דפדפן.'; err.hidden = false; btn.disabled = false; btn.textContent = 'כניסה'; return; }
      var code = form.username.value, pw = form.password.value, rem = form.remember.checked;
      login(code, pw).then(function (sess) {
        try { (rem ? localStorage : sessionStorage).setItem(KEY, JSON.stringify(sess)); } catch (x) {}
        try { if (window.PasswordCredential && navigator.credentials) navigator.credentials.store(new PasswordCredential({ id: sess.c, password: pw, name: sess.n })); } catch (x) {}
        return startSession(sess, true).then(function () {
          dlgLogin.close();
          if (sess.r === 'a') openStoreDlg(true);
          else { toast('ברוכים הבאים, ' + sess.n + '. המחירים באתר הם המחירים הסיטונאיים שלכם, לפני מע״מ.'); goShop(); }
        });
      }).catch(function () {
        err.textContent = 'שם המשתמש או הסיסמה אינם נכונים. שימו לב להבדל בין אותיות גדולות וקטנות.';
        err.hidden = false;
      }).then(function () { btn.disabled = false; btn.textContent = 'כניסה'; });
    });
  }

  /* 02.10.2026: בטלפון ובטאבלט (מסך מגע) המקלדת לא קופצת כשהחלון נפתח – אחרת היא מסתירה את החלון,
     כולל השורה "לקוח פרטי? אין צורך בכניסה". בדפדפן סמסונג הסמן נכנס לשדה גם בלי שהקוד ביקש, ולכן:
     השדות נפתחים לקריאה בלבד (readonly – מקלדת לא נפתחת גם אם הסמן בשדה), הסמן עובר לכפתור הסגירה,
     ונגיעה בשדה מחזירה אותו לכתיבה ופותחת את המקלדת. במחשב – כמו קודם, הסמן בשדה שם המשתמש. */
  function touchOnly() {
    var mm = window.matchMedia;
    var tp = (navigator.maxTouchPoints || 0) > 0 || 'ontouchstart' in window;
    return !!((mm && mm('(pointer: coarse)').matches) || (tp && ((mm && mm('(hover: none)').matches) || window.innerWidth < 1024)));
  }
  var loginOpenedAt = 0;
  function calmKeyboard() {
    loginOpenedAt = Date.now();
    var ins = dlgLogin.querySelectorAll('input:not([type="checkbox"])');
    Array.prototype.forEach.call(ins, function (i) {
      i.setAttribute('readonly', '');
      if (!i.dataset.lxro) {
        i.dataset.lxro = '1';
        var wake = function () { if (i.hasAttribute('readonly')) { i.removeAttribute('readonly'); i.focus(); } };
        i.addEventListener('touchstart', wake, { passive: true });
        i.addEventListener('pointerdown', wake);
        i.addEventListener('click', wake);
        /* מקלדת חיצונית (Tab) או מנהל סיסמאות: מעבר לשדה אחרי שהחלון כבר פתוח – גם הוא מחזיר לכתיבה */
        i.addEventListener('focus', function () { if (Date.now() - loginOpenedAt > 350) wake(); });
        i.addEventListener('keydown', wake);
      }
    });
    var x = dlgLogin.querySelector('.lx-ws-x');
    var settle = function () {
      var a = document.activeElement;
      if (a && a.tagName === 'INPUT' && !a.hasAttribute('readonly')) return; /* כבר נגעו בשדה – לא מפריעים */
      if (a && a.tagName === 'INPUT' && a.blur) a.blur();
      if (x && dlgLogin.open && document.activeElement !== x) x.focus({ preventScroll: true });
    };
    settle(); setTimeout(settle, 0); setTimeout(settle, 120);
  }
  function openLogin() {
    buildLogin(); if (!dlgLogin.open) dlgLogin.showModal();
    if (touchOnly()) { calmKeyboard(); return; }
    setTimeout(function () { var u = document.getElementById('lx-ws-u'); if (u) u.focus(); }, 30);
  }

  /* ---------- ראש האתר: מספר הפריטים על אייקון הסל + כפתור החשבון ---------- */
  function renderHeader() {
    if (!session) return;
    var t = totals(basket()), st = curStore();
    document.querySelectorAll('.lx-hd__badge').forEach(function (bd) {
      bd.textContent = t.qty; bd.removeAttribute('hidden'); bd.classList.add('lx-ws-ok');
    });
    document.querySelectorAll('a.lx-hd__cart').forEach(function (a) { a.setAttribute('aria-label', 'סל הקניות, ' + t.qty + ' פריטים'); });
    var label = isAgent() ? (st ? 'עבור: ' + st.n : 'בחירת חנות') : session.n;
    document.querySelectorAll('.lx-hd__login').forEach(function (a) {
      a.textContent = label + ' ▾';
      a.title = isAgent() ? 'סוכן: ' + session.n + (st ? ' · מזמין עבור: ' + st.n + ' · ' + st.c : '') : session.n + ' · לקוח ' + session.c;
      a.setAttribute('href', '#');
      a.setAttribute('aria-haspopup', 'menu');
      a.classList.add('lx-ws-ok', 'lx-ws-acc');
      if (!a.dataset.lxw) { a.dataset.lxw = '1'; a.addEventListener('click', function (e) { e.preventDefault(); toggleMenu(a); }); }
    });
    /* הפס העליון בטלפון: שם החנות (או "עבור: חנות" אצל סוכן) במקום "כניסת סיטונאים"; לחיצה פותחת את אותו תפריט */
    document.querySelectorAll('a.lx-top__ws').forEach(function (a) {
      a.textContent = label + ' ▾';
      a.title = isAgent() ? 'סוכן: ' + session.n + (st ? ' · מזמין עבור: ' + st.n : '') : session.n;
      a.setAttribute('href', '#');
      a.setAttribute('aria-haspopup', 'menu');
      a.classList.add('lx-ws-ok', 'lx-ws-acc');
      if (!a.dataset.lxw) { a.dataset.lxw = '1'; a.addEventListener('click', function (e) { e.preventDefault(); toggleMenu(a); }); }
    });
    /* תפריט הנייד (☰): ניווט בלבד (02.10.2026, החלטת בעל החנות). הכניסה, שם החנות, החלפת חנות והתנתקות
       נמצאים בפס העליון, שגלוי תמיד יחד עם ☰ – בלי כפילות ובלי ריבוע גדול שמרתיע לקוח פרטי. */
  }

  /* תפריט קטן מתחת לכפתור החשבון */
  function closeMenu() { if (menuEl) { menuEl.remove(); menuEl = null; } }
  function toggleMenu(anchor) {
    if (menuEl) { closeMenu(); return; }
    var st = curStore();
    menuEl = el('div', { class: 'lx-ws-menu', role: 'menu' },
      '<div class="lx-ws-menu__h">' + (isAgent()
        ? 'סוכן: ' + esc(session.n) + (st ? '<br>מזמין עבור: <b>' + esc(st.n) + '</b><br>מספר לקוח ' + esc(st.c) : '<br><b class="lx-ws-warn">לא נבחרה חנות</b>')
        : '<b>' + esc(session.n) + '</b><br>מספר לקוח ' + esc(session.c)) + '</div>' +
      (isAgent() ? '<button type="button" role="menuitem" data-m="store">' + (st ? 'החלפת חנות' : 'בחירת חנות') + '</button>' : '') +
      '<button type="button" role="menuitem" data-m="out">התנתקות</button>');
    var r = anchor.getBoundingClientRect(); menuAnchor = anchor; menuAnchorTop = r.top;
    menuEl.style.top = Math.round(r.bottom + window.scrollY + 6) + 'px';
    menuEl.style.left = Math.round(r.left + window.scrollX) + 'px';
    menuEl.style.minWidth = Math.round(r.width) + 'px';
    document.body.appendChild(menuEl);
    /* בטלפון הכפתור בפס העליון קרוב לקצה המסך: התפריט לא יוצא מהמסך */
    var mr = menuEl.getBoundingClientRect(), vw = document.documentElement.clientWidth;
    if (mr.right > vw - 8) menuEl.style.left = Math.max(8, Math.round(vw - 8 - mr.width + window.scrollX)) + 'px';
    if (mr.left < 8) menuEl.style.left = Math.round(8 + window.scrollX) + 'px';
    menuEl.addEventListener('click', function (e) {
      var m = e.target.closest('[data-m]'); if (!m) return;
      var k = m.getAttribute('data-m'); closeMenu();
      if (k === 'store') openStoreDlg(false);
      if (k === 'out') logout();
    });
    var b = menuEl.querySelector('button'); if (b) b.focus();
  }
  document.addEventListener('click', function (e) { if (menuEl && !menuEl.contains(e.target) && !e.target.closest('.lx-hd__login, .lx-top__ws')) closeMenu(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  window.addEventListener('resize', closeMenu);
  /* 02.10.2026 (ערכה 15): במחשב נגלל אזור פנימי של התבנית ולא הדף, ולכן התפריט הקטן נשאר "תלוי" במסך כשגוללים.
     נסגר בגלילה – רק אם הכפתור באמת זז (אחרת אירוע הגלילה שנוצר מהמיקוד בפתיחה היה סוגר אותו מיד). */
  document.addEventListener('scroll', function () {
    if (menuEl && menuAnchor && Math.abs(menuAnchor.getBoundingClientRect().top - menuAnchorTop) > 2) closeMenu();
  }, true);

  /* ---------- סוכן: בחירת חנות ---------- */
  function norm(x) { return String(x || '').replace(/["'״׳.\-]/g, '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function openStoreDlg(first) {
    if (!dlgStore) {
      dlgStore = el('dialog', { class: 'lx-ws-dlg', 'aria-labelledby': 'lx-ws-sth' });
      document.body.appendChild(dlgStore);
    }
    var st = curStore();
    dlgStore.innerHTML = '<div class="lx-ws-form">' +
      '<button type="button" class="lx-ws-x" aria-label="סגירה">×</button>' +
      '<h2 id="lx-ws-sth">' + (first ? 'שלום ' + esc(session.n) : 'בחירת חנות') + '</h2>' +
      '<p>בחר את החנות שעבורה תבוצע ההזמנה. אפשר להקליד כמה אותיות משם החנות או ספרות ממספר הלקוח.</p>' +
      (st ? '<p class="lx-ws-sub">כרגע: ' + esc(st.n) + ' · ' + esc(st.c) + '</p>' : '') +
      '<label for="lx-ws-st" class="lx-ws-vh">בחר חנות</label>' +
      '<input id="lx-ws-st" class="lx-ws-stin" type="text" autocomplete="off" placeholder="בחר חנות" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="lx-ws-stl">' +
      '<ul id="lx-ws-stl" class="lx-ws-list" role="listbox" hidden></ul>' +
      '</div>';
    var inp = dlgStore.querySelector('#lx-ws-st'), list = dlgStore.querySelector('#lx-ws-stl'), items = [], act = -1;
    dlgStore.querySelector('.lx-ws-x').addEventListener('click', function () { dlgStore.close(); });
    function close() { list.hidden = true; inp.setAttribute('aria-expanded', 'false'); act = -1; }
    function show(q) {
      q = norm(q);
      if (!q) { items = []; close(); return; }
      var digits = /^\d+$/.test(q);
      items = (STORES || []).filter(function (s) { return digits ? s[0].indexOf(q) === 0 : norm(s[1]).indexOf(q) !== -1; });
      if (!digits) items.sort(function (x, y) { return (norm(x[1]).indexOf(q) === 0 ? 0 : 1) - (norm(y[1]).indexOf(q) === 0 ? 0 : 1); });
      items = items.slice(0, 20);
      list.innerHTML = items.length ? items.map(function (s, i) {
        return '<li role="option" id="lx-ws-o' + i + '" data-i="' + i + '"><b>' + esc(s[1]) + '</b> <span dir="ltr">' + esc(s[0]) + '</span></li>';
      }).join('') : '<li class="lx-ws-none">לא נמצאה חנות</li>';
      list.hidden = false; inp.setAttribute('aria-expanded', 'true'); act = -1;
    }
    function pick(i) {
      var s = items[i]; if (!s) return;
      setStore({ c: s[0], n: s[1] });
      dlgStore.close();
      toast('מזמין עבור: ' + s[1]);
      goShop();
    }
    function mark() {
      Array.prototype.forEach.call(list.querySelectorAll('li[data-i]'), function (li, i) { li.classList.toggle('is-act', i === act); });
      if (act >= 0) inp.setAttribute('aria-activedescendant', 'lx-ws-o' + act); else inp.removeAttribute('aria-activedescendant');
    }
    inp.addEventListener('input', function () { show(inp.value); });
    inp.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); act = Math.min(items.length - 1, act + 1); mark(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); act = Math.max(0, act - 1); mark(); }
      else if (e.key === 'Enter') { e.preventDefault(); pick(act < 0 ? 0 : act); }
    });
    list.addEventListener('click', function (e) { var li = e.target.closest('li[data-i]'); if (li) pick(+li.getAttribute('data-i')); });
    if (!dlgStore.open) dlgStore.showModal();
    setTimeout(function () { inp.focus(); }, 30);
  }

  /* ---------- עמוד הסל (/cart): הסל הסיטונאי במקום הסל הרגיל, באותו מקום ובאותו מבנה ---------- */
  function renderCart() {
    if (!ON_CART || !session) return;
    if (!cartBox) {
      var main = document.querySelector('main');
      if (!main) return;
      var sec = main.querySelector('[id$="__cart-section"]');
      cartBox = el('section', { class: 'lx-wc', 'aria-labelledby': 'lx-wc-h' });
      if (sec) sec.parentNode.insertBefore(cartBox, sec); else main.insertBefore(cartBox, main.firstChild);
      cartBox.addEventListener('click', onCartClick);
      cartBox.addEventListener('change', onCartChange);
      cartBox.addEventListener('input', function (e) { if (e.target.id === 'lx-wc-note') { try { sessionStorage.setItem(NOTE, e.target.value); } catch (x) {} } });
    }
    var b = basket(), t = totals(b), st = curStore();
    var note = ''; try { note = sessionStorage.getItem(NOTE) || ''; } catch (x) {}
    var who = isAgent()
      ? '<p class="lx-wc__for">' + (st ? 'מזמין עבור: <b>' + esc(st.n) + '</b> · מספר לקוח ' + esc(st.c) : '<b class="lx-ws-warn">לא נבחרה חנות</b>') +
        ' <button type="button" class="lx-wc__link" data-a="store">' + (st ? 'החלפת חנות' : 'בחירת חנות') + '</button></p>'
      : '<p class="lx-wc__for">' + esc(session.n) + ' · מספר לקוח ' + esc(session.c) + '</p>';
    var rows = b.map(function (l, i) {
      var p = priceOf(l.sku);
      return '<li class="lx-wc__row">' +
        (l.img ? '<img class="lx-wc__img" src="' + esc(l.img) + '" alt="" width="96" height="96" loading="lazy">' : '<span class="lx-wc__img lx-wc__img--no" aria-hidden="true"></span>') +
        '<div class="lx-wc__info"><div class="lx-wc__name">' + esc(l.n || l.sku) + '</div>' +
        '<div class="lx-wc__sku" dir="ltr">' + esc(l.sku) + '</div>' +
        '<div class="lx-wc__unit">' + (p == null ? 'מחיר לפי בקשה' : '₪' + n2(p) + ' ליחידה, לפני מע״מ') + '</div>' +
        '<div class="lx-wc__qrow"><div class="lx-ws-q"><button type="button" data-a="dec" data-i="' + i + '" aria-label="הפחתת כמות">−</button>' +
        '<input type="number" min="1" inputmode="numeric" value="' + l.q + '" data-i="' + i + '" aria-label="כמות">' +
        '<button type="button" data-a="inc" data-i="' + i + '" aria-label="הוספת כמות">+</button></div>' +
        '<button type="button" class="lx-wc__del" data-a="del" data-i="' + i + '" aria-label="הסרה מהסל">הסרה</button></div></div>' +
        '<div class="lx-wc__line">' + (p == null ? '—' : '₪' + n2(p * l.q)) + '</div></li>';
    }).join('');
    cartBox.innerHTML = '<div class="lx-wc__in">' +
      '<h1 id="lx-wc-h" class="lx-wc__title">סל הקניות <span>(' + t.qty + ')</span></h1>' + who +
      (b.length ?
        '<div class="lx-wc__grid"><ul class="lx-wc__list">' + rows + '</ul>' +
        '<aside class="lx-wc__sum"><dl><dt>סה״כ לפני מע״מ</dt><dd>₪' + money2(t.sub) + '</dd><dt>מע״מ 18%</dt><dd>₪' + money2(t.vat) + '</dd>' +
        '<dt class="lx-wc__tot">סה״כ כולל מע״מ</dt><dd class="lx-wc__tot">₪' + n2(t.total) + '</dd></dl>' +
        (t.missing ? '<p class="lx-ws-sub">' + t.missing + ' פריטים במחיר לפי בקשה אינם כלולים בסכום.</p>' : '') +
        '<label for="lx-wc-note">הערות להזמנה (כתובת אספקה, איש קשר וכו׳)</label><textarea id="lx-wc-note" rows="3">' + esc(note) + '</textarea>' +
        '<button type="button" class="lx-ws-btn lx-wc__send" data-a="send">שליחת ההזמנה</button>' +
        '<button type="button" class="lx-ws-btn lx-ws-btn--alt" data-a="wa">שליחה בוואטסאפ</button>' +
        '<p class="lx-ws-sub">ההזמנה נשלחת ל-LUCCINI בלי תשלום באתר. החיוב לפי תנאי האשראי של החשבון.</p></aside></div>'
        : '<p class="lx-wc__empty">הסל שלך ריק.</p><a class="lx-ws-btn lx-wc__cont" href="/collections/all">להמשך קנייה</a>') +
      '</div>';
  }

  function onCartChange(e) {
    var i = e.target.getAttribute('data-i');
    if (i == null || e.target.tagName !== 'INPUT') return;
    var b = basket(); if (!b[+i]) return;
    b[+i].q = Math.max(1, parseInt(e.target.value, 10) || 1); saveBasket(b);
  }

  function onCartClick(e) {
    var a = e.target.closest('[data-a]'); if (!a) return;
    var act = a.getAttribute('data-a'), i = +a.getAttribute('data-i'), b = basket();
    if (act === 'store') { openStoreDlg(false); return; }
    if ((act === 'send' || act === 'wa') && isAgent() && !curStore()) { openStoreDlg(false); return; }
    if (act === 'send') { sendOrder(); return; }
    if (act === 'wa') { window.open('https://wa.me/' + (CFG.phone || '') + '?text=' + encodeURIComponent(orderText()), '_blank', 'noopener'); return; }
    if (!b[i]) return;
    if (act === 'inc') b[i].q++;
    if (act === 'dec') b[i].q = Math.max(1, b[i].q - 1);
    if (act === 'del') b.splice(i, 1);
    saveBasket(b);
  }

  /* טקסט ההזמנה (מייל ווואטסאפ): כל שורה מתחילה בסימן כיוון ימין-לשמאל (RLM) בלתי נראה,
     כך שגם שורה שמתחילה במק"ט לועזי מיושרת לימין ונקראת כמו עברית. פריט = 3 שורות קצרות שנכנסות לרוחב טלפון. */
  function orderText() {
    var RLM = '\u200F';
    var b = basket(), t = totals(b), d = new Date();
    var note = ''; try { note = (sessionStorage.getItem(NOTE) || '').trim(); } catch (x) {}
    var pad = function (x) { return (x < 10 ? '0' : '') + x; };
    var st = curStore();
    var lines = isAgent()
      ? ['הזמנת סוכן – LUCCINI', 'הסוכן: ' + session.n + (CFG.agentPhone ? ' · ' + CFG.agentPhone : ''), 'עבור: ' + (st ? st.n : ''), 'מספר לקוח: ' + (st ? st.c : '')]
      : ['הזמנת לקוח סיטונאי – LUCCINI', 'לקוח: ' + session.n, 'מספר לקוח: ' + session.c];
    lines.push('תאריך: ' + pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()), '');
    b.forEach(function (l, i) {
      var p = priceOf(l.sku);
      lines.push((i + 1) + '. ' + (l.n || l.sku),
        'מק"ט: ' + l.sku,
        'כמות: ' + l.q + ' · ' + (p == null ? 'מחיר לפי בקשה' : 'מחיר ליח׳: ₪' + n2(p) + ' · סה"כ: ₪' + n2(p * l.q)),
        '');
    });
    lines.push('------------------------------',
      'סה"כ לפני מע"מ: ₪' + money2(t.sub),
      'מע"מ 18%: ₪' + money2(t.vat),
      'סה"כ כולל מע"מ: ₪' + n2(t.total));
    if (t.missing) lines.push('פריטים במחיר לפי בקשה: ' + t.missing + ' (לא כלולים בסכום)');
    if (note) { lines.push(''); note.split(/\r?\n/).forEach(function (x, k) { lines.push((k ? '' : 'הערות: ') + x); }); }
    return lines.map(function (x) { return x ? RLM + x : x; }).join('\n');
  }

  /* ---------- מייל ההזמנה המעוצב (EmailJS) ---------- */
  function orderMeta() {
    var st = curStore(), d = new Date();
    var pad = function (x) { return (x < 10 ? '0' : '') + x; };
    return {
      agent: isAgent(),
      custName: isAgent() ? (st ? st.n : '') : session.n,
      custCode: isAgent() ? (st ? st.c : '') : session.c,
      date: pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
    };
  }
  function orderSubject() {
    var m = orderMeta(), t = totals(basket());
    return (m.agent ? 'הזמנת סוכן' : 'הזמנת לקוח סיטונאי') + ' – ' + m.custName + ' (' + m.custCode + ') – ₪' + n2(t.total);
  }
  function orderHtml() {
    /* מותאם לטלפון: בלי רוחב קבוע בשום מקום; כל פריט בשתי שורות (03.10.2026); הכול מיושר לימין */
    var b = basket(), t = totals(b), m = orderMeta();
    var note = ''; try { note = (sessionStorage.getItem(NOTE) || '').trim(); } catch (x) {}
    var F = "font-family:Arial,Helvetica,sans-serif;", C = 'color:#171412;';
    /* כותרות הטבלה והלוגו בכיתוב שחור: נקראים גם במדפסת שלא מדפיסה צבעי רקע */
    var th = function (al) { return 'style="' + F + C + 'background:#e9e5df;font-size:13px;font-weight:bold;padding:7px 4px;text-align:' + (al || 'right') + ';border:1px solid #9c958d;border-bottom:2px solid #171412;"'; };
    var td = function (x) { return 'style="' + F + C + 'font-size:14px;padding:7px 4px;border:1px solid #d9d4ce;vertical-align:top;' + (x || '') + '"'; };
    var row = function (k, v) { return '<tr><td style="' + F + 'color:#6b6660;font-size:14px;padding:2px 0 2px 10px;vertical-align:top;white-space:nowrap;">' + k + '</td><td style="' + F + C + 'font-size:14px;font-weight:bold;padding:2px 0;vertical-align:top;">' + v + '</td></tr>'; };
    /* 03.10.2026: כל פריט בשתי שורות (שם ומק״ט, ואז כמות · ליח׳ · סה״כ) במקום טבלה של 5 עמודות –
       ב-Gmail בטלפון עם גופן מוגדל העמודות "ליח׳" ו"סה״כ" נחתכו. כל חלק עובר שורה כיחידה אחת. */
    var seg = function (k, v, strong, ltr) {
      return '<span style="white-space:nowrap;display:inline-block;margin-left:16px;">' + k + ' <span' + (ltr ? ' dir="ltr"' : '') + ' style="' + (strong ? 'font-weight:bold;' : '') + '">' + v + '</span></span>';
    };
    var items = b.map(function (l, i) {
      var p = priceOf(l.sku);
      return '<tr><td style="' + F + C + 'font-size:14px;padding:9px 6px;border-bottom:1px solid #d9d4ce;vertical-align:top;' + (i % 2 ? 'background:#faf8f5;' : '') + '">' +
        '<div style="font-weight:bold;font-size:15px;line-height:1.4;">' + (i + 1) + '. ' + esc(l.n || l.sku) + '</div>' +
        '<div style="color:#6b6660;font-size:13px;margin-top:2px;">מק״ט: <span dir="ltr" style="white-space:nowrap;">' + esc(l.sku) + '</span></div>' +
        '<div style="margin-top:4px;line-height:1.8;">' +
        seg('כמות:', l.q, true, true) +
        seg('ליח׳:', p == null ? 'לפי בקשה' : '₪' + n2(p), false, p != null) +
        seg('סה״כ:', p == null ? '—' : '₪' + n2(p * l.q), true, p != null) +
        '</div></td></tr>';
    }).join('');
    var sumRow = function (k, v, strong) {
      var st = F + C + 'font-size:' + (strong ? '16px;font-weight:bold;border-top:2px solid #171412;' : '14px;') + 'padding:5px 8px;';
      return '<tr><td style="' + st + 'text-align:right;">' + k + '</td><td dir="ltr" style="' + st + 'text-align:left;white-space:nowrap;">' + v + '</td></tr>';
    };
    /* המעטפת היא div ולא טבלה: כך בהדפסה התוכן ממשיך מיד אחרי כותרות Gmail באותו דף, ולא נדחף כולו לדף הבא */
    return '<div dir="rtl" style="' + F + C + 'direction:rtl;text-align:right;max-width:820px;margin:0 auto;background:#fff;padding:12px 10px;">' +
      '<div style="' + F + C + 'border:2px solid #171412;font-size:18px;font-weight:bold;letter-spacing:3px;padding:6px 12px;display:inline-block;">LUCCINI</div>' +
      '<h1 style="' + F + C + 'font-size:20px;margin:14px 0 10px;">' + (m.agent ? 'הזמנת סוכן' : 'הזמנת לקוח סיטונאי') + '</h1>' +
      '<table role="presentation" dir="rtl" cellpadding="0" cellspacing="0" style="border-collapse:collapse;margin:0 0 14px;">' +
      row('לקוח:', esc(m.custName)) + row('מספר לקוח:', esc(m.custCode)) +
      (m.agent ? row('הסוכן:', esc(session.n) + (CFG.agentPhone ? '<br><span dir="ltr">' + esc(CFG.agentPhone) + '</span>' : '')) : '') +
      row('תאריך:', '<span dir="ltr">' + m.date + '</span>') + '</table>' +
      '<table dir="rtl" width="100%" cellpadding="0" cellspacing="0" style="width:100%;border-collapse:collapse;">' +
      '<tr><th ' + th() + '>פריטים בהזמנה (' + b.length + ')</th></tr>' + items + '</table>' +
      '<table role="presentation" dir="rtl" align="left" cellpadding="0" cellspacing="0" style="width:100%;max-width:320px;border-collapse:collapse;background:#f4f2ef;margin-top:12px;">' +
      sumRow('סה״כ לפני מע״מ', '₪' + money2(t.sub)) + sumRow('מע״מ 18%', '₪' + money2(t.vat)) + sumRow('סה״כ כולל מע״מ', '₪' + n2(t.total), true) +
      '</table><div style="clear:both;height:1px;line-height:1px;font-size:1px;">&nbsp;</div>' +
      (t.missing ? '<p style="' + F + 'color:#6b6660;font-size:13px;">' + t.missing + ' פריטים במחיר לפי בקשה אינם כלולים בסכום.</p>' : '') +
      (note ? '<div style="' + F + C + 'margin-top:14px;border-right:4px solid #b08d3e;background:#faf6ec;padding:10px 12px;font-size:15px;font-weight:bold;line-height:1.6;">הערות להזמנה:<br>' + esc(note).replace(/\n/g, '<br>') + '</div>' : '') +
      '<p style="' + F + 'color:#8a847d;font-size:12px;margin:18px 0 0;">נשלח מאתר LUCCINI – אזור הסיטונאים.</p>' +
      '</div>';
  }

  var sending = false;
  /* "שליחת ההזמנה": שליחה ישירה במייל המעוצב. אם נכשלת – מעבר מיידי לדף "צור קשר" עם הטופס ממולא */
  function sendOrder() {
    if (sending) return;
    var st = curStore();
    var fb = {
      n: isAgent() ? 'סוכן ' + session.n + ' עבור ' + (st ? st.c + ' ' + st.n : '') : session.c + ' ' + session.n,
      e: CFG.replyTo || CFG.email || '',
      p: isAgent() ? (CFG.agentPhone || '') : '',
      b: orderText()
    };
    try { sessionStorage.setItem(SEND, JSON.stringify(fb)); } catch (x) {}
    function fallback() { sending = false; location.href = '/pages/contact?ws=send&fb=1'; }
    var ej = CFG.emailjs;
    var htmlBody = orderHtml();
    if (!ej || !ej.service || !ej.template || !ej.key || !window.fetch || htmlBody.length > 45000) { fallback(); return; }
    sending = true;
    var btn = cartBox && cartBox.querySelector('[data-a="send"]');
    if (btn) { btn.disabled = true; btn.textContent = 'שולח את ההזמנה...'; }
    var done = false;
    var timer = setTimeout(function () { if (!done) { done = true; fallback(); } }, 20000);
    fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ service_id: ej.service, template_id: ej.template, user_id: ej.key, template_params: { subject: orderSubject(), order_html: htmlBody } })
    }).then(function (r) {
      if (done) return;
      done = true; clearTimeout(timer);
      if (r.ok) orderSent(); else fallback();
    }, function () {
      if (done) return;
      done = true; clearTimeout(timer); fallback();
    });
  }

  /* ההזמנה נשלחה: מרוקנים את הסל ומציגים אישור */
  function orderSent() {
    sending = false;
    try { localStorage.removeItem(BASKET); sessionStorage.removeItem(STORE); sessionStorage.removeItem(SEND); sessionStorage.removeItem(NOTE); } catch (x) {}
    refresh();
    var d = el('dialog', { class: 'lx-ws-dlg', 'aria-labelledby': 'lx-ws-ok' },
      '<div class="lx-ws-form"><h2 id="lx-ws-ok">ההזמנה נשלחה</h2><p>תודה! ההזמנה התקבלה ב-LUCCINI.</p>' +
      '<button type="button" class="lx-ws-btn">סגירה</button></div>');
    document.body.appendChild(d); d.showModal();
    d.querySelector('button').addEventListener('click', function () { d.close(); if (isAgent()) openStoreDlg(false); });
  }

  /* דף "צור קשר" עם ‎?ws=send: ממלא את הטופס הרגיל ומציג כותרת "אישור ושליחת ההזמנה" */
  function contactForm() {
    var fs = document.querySelectorAll('main form[action*="/contact"]');
    for (var i = 0; i < fs.length; i++) if (fs[i].id !== 'lx-ws-order') return fs[i];
    return null;
  }
  function prepareSend() {
    if (!/[?&]ws=send/.test(location.search)) return;
    var data = null; try { data = JSON.parse(sessionStorage.getItem(SEND) || 'null'); } catch (x) {}
    var f = contactForm();
    if (!data || !f) return;
    function set(sel, v) { var x = f.querySelector(sel); if (x) x.value = v; return x; }
    set('[name="contact[name]"]', data.n);
    set('[name="contact[email]"]', data.e);
    if (data.p) set('[name="contact[phone]"]', data.p);
    var body = set('[name="contact[body]"]', data.b);
    if (body) { body.setAttribute('dir', 'rtl'); body.rows = Math.min(28, Math.max(12, data.b.split('\n').length + 1)); }
    var box = el('div', { class: 'lx-ws-confirm', role: 'region', 'aria-labelledby': 'lx-ws-cf' },
      '<h2 id="lx-ws-cf">אישור ושליחת ההזמנה</h2>' +
      (/[?&]fb=1/.test(location.search) ? '<p><b>השליחה הישירה לא הצליחה הפעם, ולכן ההזמנה עברה לכאן.</b></p>' : '') +
      '<p>פרטי ההזמנה כבר מולאו בטופס שלמטה. לחצו על כפתור השליחה בתחתית הטופס, וההזמנה תישלח.</p>' +
      '<a class="lx-ws-btn lx-ws-btn--alt lx-ws-btn--sm" href="/cart">חזרה לסל</a>');
    f.parentNode.insertBefore(box, f);
    f.addEventListener('submit', function () { try { sessionStorage.setItem(PENDING, '1'); } catch (x) {} }, true);
    box.scrollIntoView({ block: 'start' });
  }

  /* ההזמנה לא נשלחה: הודעה ברורה + שליחה בוואטסאפ. הסל נשמר. */
  function failDialog() {
    var d = el('dialog', { class: 'lx-ws-dlg', 'aria-labelledby': 'lx-ws-fail' },
      '<div class="lx-ws-form lx-ws-center"><h2 id="lx-ws-fail">ההזמנה לא נשלחה</h2>' +
      '<p>השליחה לא הושלמה. הסל נשמר ולא נמחק דבר.</p><p>אפשר לנסות שוב, או לשלוח את אותה הזמנה בוואטסאפ.</p>' +
      '<div class="lx-ws-acts"><button type="button" class="lx-ws-btn" data-a="wa">שליחה בוואטסאפ</button>' +
      '<button type="button" class="lx-ws-btn lx-ws-btn--alt" data-a="again">לסל ולניסיון נוסף</button></div></div>');
    document.body.appendChild(d); d.showModal();
    d.querySelector('[data-a="wa"]').addEventListener('click', function () { window.open('https://wa.me/' + (CFG.phone || '') + '?text=' + encodeURIComponent(orderText()), '_blank', 'noopener'); });
    d.querySelector('[data-a="again"]').addEventListener('click', function () { d.close(); location.href = '/cart'; });
  }

  function checkPosted() {
    var pending = false; try { pending = sessionStorage.getItem(PENDING) === '1'; } catch (x) {}
    if (!pending) return;
    var ok = /[?&]contact_posted=true/.test(location.search);
    var f = document.getElementById('lx-ws-order');
    var cf = contactForm();
    var hasErr = !!((f && f.querySelector('[name="lx_err"]')) || (cf && cf.querySelector('.contact-form__error')));
    if ((f && f.querySelector('[name="lx_ok"]')) || (cf && cf.querySelector('.contact-form__success'))) ok = true;
    try { sessionStorage.removeItem(PENDING); } catch (x) {}
    if (!ok && !hasErr) { failDialog(); return; }
    if (ok && !hasErr) {
      orderSent();
    } else {
      failDialog();
    }
  }

  /* חזרה אחורה מדף שגיאה של Shopify: הדף משוחזר מהזיכרון בלי טעינה מחדש */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !session) return;
    var pending = false; try { pending = sessionStorage.getItem(PENDING) === '1'; } catch (x) {}
    if (!pending) return;
    refresh();
    checkPosted();
  });

  /* ---------- הפעלה ---------- */
  function init() {
    var sess = readStore(KEY);
    if (sess && sess.k && sess.c && subtle) {
      startSession(sess, true).catch(function () {
        try { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {}
        html.classList.remove('lx-ws'); session = null; buildEntry();
        toast('יש להתחבר מחדש לחשבון הסיטונאי');
      });
    } else {
      html.classList.remove('lx-ws');
      buildEntry();
    }
    if (/[?&#]ws=login/.test(location.search + location.hash) && !sess) openLogin();
  }

  window.lxWsLogin = openLogin;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* לבדיקות אוטומטיות בלבד */
  window.__lxWsTest = { login: login, loadPrices: loadPrices, loadStores: loadStores };
})();